import { Box } from "@mui/material";
import { Card } from "@pav/pav-products-design-system";

export default function StatusUpdateCard({ icon, heading, body }) {
  return (
    <Card
      themeVariant="statusMessage"
      sx={{ width: "100%", marginBottom: "32px" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--spacing-md)",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {icon}
        </Box>
        <Box className="header">{heading}</Box>
        <Box
          sx={{
            fontWeight: "var(--weight-regular)",
            color: "var(--color-secondary-gray-tint-80)",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          {body}
        </Box>
      </Box>
    </Card>
  );
}
